import { render, staticRenderFns } from "./month-wage-detail-modal.vue?vue&type=template&id=2127584f&scoped=true"
import script from "./month-wage-detail-modal.vue?vue&type=script&lang=js"
export * from "./month-wage-detail-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2127584f",
  null
  
)

export default component.exports